// window.updateCardVariant = function(cardId, swatchElement, event) {
//   event.preventDefault();
//   event.stopPropagation();

//   const variantFeaturedImageSrc = swatchElement.getAttribute('data-variant-featured-image-src');
//   const variantFeaturedImageSrcset = swatchElement.getAttribute('data-variant-featured-image-srcset');
//   const variantFeaturedImageAlt = swatchElement.getAttribute('data-display-image-alt');
//   const variantId = swatchElement.getAttribute('data-variant-id');

//   const mainImage = document.getElementById(cardId + '-main-image');
//   const hoverImage = document.getElementById(cardId + '-hover-image');
//   const cardLink = document.getElementById(cardId + '-link');

//   if (mainImage) {
//     const finalSrc = variantFeaturedImageSrc || mainImage.getAttribute('data-original-src');
//     const finalSrcset = variantFeaturedImageSrcset || mainImage.getAttribute('data-original-srcset');

//     if (finalSrc) {
//       mainImage.style.transition = 'opacity 0.3s ease';
//       mainImage.style.opacity = '0.5';
//       const tempImg = new Image();
//       tempImg.onload = function() {
//         mainImage.setAttribute('src', finalSrc);
//         if (finalSrcset) mainImage.setAttribute('srcset', finalSrcset);
//         if (variantFeaturedImageAlt) mainImage.setAttribute('alt', variantFeaturedImageAlt);
//         mainImage.style.opacity = '1';
//       };
//       tempImg.src = finalSrc;
//     }
//   }

//   if (cardLink && variantId) {
//     const baseUrl = cardLink.getAttribute('href').split('?')[0];
//     cardLink.setAttribute('href', baseUrl + '?variant=' + variantId);
//   }

//   const swatches = swatchElement.closest('.card__color-swatches').querySelectorAll('.color-swatch');
//   swatches.forEach(s => s.classList.remove('color-swatch--active'));
//   swatchElement.classList.add('color-swatch--active');
// };

function setCardHoverImage(cardId, swatchElement) {
  if (!swatchElement) return;

  const colorHandle = (swatchElement.getAttribute('data-color') || '').trim();
  const variantFeaturedImageAlt =
    (
      swatchElement.getAttribute('data-display-image-alt') ||
      swatchElement.getAttribute('aria-label') ||
      swatchElement.getAttribute('title') ||
      ''
    ).trim();

  const hoverImage = document.getElementById(cardId + '-hover-image');
  const swatchWrapper = swatchElement.closest('.card__color-swatches');

  if (!hoverImage || !swatchWrapper || !colorHandle) return;

  let hoverContainer = swatchElement.previousElementSibling;

  // nearest previous .container_get_hover_image
  if (!hoverContainer || !hoverContainer.classList.contains('container_get_hover_image')) {
    const children = Array.from(swatchWrapper.children);
    const swatchIndex = children.indexOf(swatchElement);

    hoverContainer = null;

    for (let i = swatchIndex - 1; i >= 0; i--) {
      if (
        children[i] &&
        children[i].classList &&
        children[i].classList.contains('container_get_hover_image')
      ) {
        hoverContainer = children[i];
        break;
      }
    }

    if (!hoverContainer) {
      hoverContainer = swatchWrapper.querySelector('.container_get_hover_image');
    }
  }

  if (!hoverContainer) return;

  const targetClass = colorHandle + '-2';
  const allHoverImages = Array.from(hoverContainer.querySelectorAll('img'));

  // 1st priority: same alt + same class
  let matchedHoverImage = allHoverImages.find(function(img) {
    const hoverAlt = (img.getAttribute('data-alt-hover') || '').trim().toLowerCase();
    return (
      hoverAlt === variantFeaturedImageAlt.toLowerCase() &&
      img.classList.contains(targetClass)
    );
  });

  // 2nd priority: only class match
  if (!matchedHoverImage) {
    matchedHoverImage = allHoverImages.find(function(img) {
      return img.classList.contains(targetClass);
    });
  }

  if (!matchedHoverImage) return;

  const hoverSrc =
    matchedHoverImage.getAttribute('data-hover-src') ||
    matchedHoverImage.getAttribute('src') ||
    '';

  const hoverSrcset =
    matchedHoverImage.getAttribute('data-hover-srcset') ||
    matchedHoverImage.getAttribute('srcset') ||
    '';

  const hoverAlt =
    matchedHoverImage.getAttribute('data-alt-hover') ||
    matchedHoverImage.getAttribute('alt') ||
    variantFeaturedImageAlt ||
    '';

  if (!hoverSrc) return;

  hoverImage.setAttribute('src', hoverSrc);

  if (hoverSrcset) {
    hoverImage.setAttribute('srcset', hoverSrcset);
  } else {
    hoverImage.removeAttribute('srcset');
  }

  if (hoverAlt) {
    hoverImage.setAttribute('alt', hoverAlt);
  }
}

function setCardSaleBadge(cardId, swatchElement) {
  if (!swatchElement) return;

  const cardWrapper = document.querySelector('.card-wrapper[data-card-id="' + cardId + '"]');
  if (!cardWrapper) return;

  const badgesTop = cardWrapper.querySelector('.card__badges-top');
  if (!badgesTop) return;

  const variantPrice = parseFloat(swatchElement.getAttribute('data-variant-price')) || 0;
  const variantCompareAtPrice = parseFloat(swatchElement.getAttribute('data-variant-compare-at-price')) || 0;

  const isOnSale = variantCompareAtPrice > variantPrice && variantPrice > 0;

  badgesTop.classList.remove('on_sale', 'not_on_sale');
  badgesTop.classList.add(isOnSale ? 'on_sale' : 'not_on_sale');
}
// AZ Start


function initializeSwatchWrapping() {
  const allSwatchContainers = document.querySelectorAll('.card__color-swatches');
  
  allSwatchContainers.forEach(function(container) {
    const swatches = Array.from(container.querySelectorAll('.color-swatch'));
    
    if (swatches.length <= 3) return;
    
    swatches.forEach(function(swatch, index) {
      if (index >= 3) {
        swatch.classList.add('swatch-hidden');
          swatch.style.display = 'none';
      }
    });
    
    if (!container.querySelector('.swatch-more-btn')) {
      const hiddenCount = swatches.length - 3;
      const moreBtn = document.createElement('button');
      moreBtn.className = 'swatch-more-btn';
      moreBtn.textContent = '+' + hiddenCount;
      moreBtn.setAttribute('type', 'button');
      
      moreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleHiddenSwatches(container);
      });
      
      container.appendChild(moreBtn);
    }
  });
}

function toggleHiddenSwatches(container) {
  const allSwatches = Array.from(container.querySelectorAll('.color-swatch'));
  const moreBtn = container.querySelector('.swatch-more-btn');
  
  allSwatches.forEach(function(swatch) {
    swatch.classList.remove('swatch-hidden');
    swatch.style.display = '';
  });
  container.classList.add('swatches-expanded');
  moreBtn.style.display = 'none';
}
// AZ END

window.updateCardVariant = function(cardId, swatchElement, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const variantFeaturedImageSrc =
    swatchElement.getAttribute('data-variant-featured-image-src') || '';

  const variantFeaturedImageSrcset =
    swatchElement.getAttribute('data-variant-featured-image-srcset') || '';

  const variantFeaturedImageAlt =
    (
      swatchElement.getAttribute('data-display-image-alt') ||
      swatchElement.getAttribute('aria-label') ||
      swatchElement.getAttribute('title') ||
      ''
    ).trim();

  const variantId = swatchElement.getAttribute('data-variant-id') || '';

  const mainImage = document.getElementById(cardId + '-main-image');
  const cardLink = document.getElementById(cardId + '-link');
  const swatchWrapper = swatchElement.closest('.card__color-swatches');

  /* Main image update with fade */
  if (mainImage) {
    const finalSrc =
      variantFeaturedImageSrc || mainImage.getAttribute('data-original-src') || '';

    const finalSrcset =
      variantFeaturedImageSrcset || mainImage.getAttribute('data-original-srcset') || '';

    if (finalSrc) {
      mainImage.style.transition = 'opacity 0.3s ease';
      mainImage.style.opacity = '0.5';

      const tempImg = new Image();
      tempImg.onload = function() {
        mainImage.setAttribute('src', finalSrc);

        if (finalSrcset) {
          mainImage.setAttribute('srcset', finalSrcset);
        } else {
          mainImage.removeAttribute('srcset');
        }

        if (variantFeaturedImageAlt) {
          mainImage.setAttribute('alt', variantFeaturedImageAlt);
        }

        mainImage.style.opacity = '1';
      };

      tempImg.onerror = function() {
        mainImage.style.opacity = '1';
      };

      tempImg.src = finalSrc;
    }
  }

  /* Product link update */
  if (cardLink && variantId) {
    const currentHref = cardLink.getAttribute('href') || '';
    const baseUrl = currentHref.split('?')[0];
    cardLink.setAttribute('href', baseUrl + '?variant=' + variantId);
  }

  /* Active swatch state */
  if (swatchWrapper) {
    const swatches = swatchWrapper.querySelectorAll('.color-swatch');
    swatches.forEach(function(s) {
      s.classList.remove('color-swatch--active');
    });
  }

  swatchElement.classList.add('color-swatch--active');

  /* Hover image update */
  setCardHoverImage(cardId, swatchElement);

  /* Sale badge update */
  setCardSaleBadge(cardId, swatchElement);

  return false;
};

/* Page load pe active swatch ke hisab se hover image set karo */
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.card-wrapper[data-card-id]');

  cards.forEach(function(card) {
    const cardId = card.getAttribute('data-card-id');
    if (!cardId) return;

    const activeSwatch =
      card.querySelector('.card__color-swatches .color-swatch.color-swatch--active') ||
      card.querySelector('.card__color-swatches .color-swatch');

    if (activeSwatch) {
      setCardHoverImage(cardId, activeSwatch);
      setCardSaleBadge(cardId, activeSwatch);
    }
  });
  // AZ Start

   initializeSwatchWrapping();

  // AZ END
});